import { faBroom, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { Envelope, EyeFill, EyeSlashFill, List, Search } from "react-bootstrap-icons";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { getStaffExtSettings } from "../store/api/SystemSettingsAPI";
import { isMobileApp, setDialog, setErrorDialog } from "../../store/api/CommonFunctions";
import { useHistory } from "react-router-dom";
import BihamtaTable from "../../Components/BihamtaTable";
import { deleteStaff, getStaffMobilesByFilter, searchStaff} from "../store/api/StaffApi";
import ModalSelectUser from "../../Components/Modals/ModalSelectUser";
import ModalSendSMS from "../../Components/Modals/ModalSendSMS";

const SearchPersonnel = () => {
    const frmFilters = useRef();
    const history = useHistory();
    const dispatch = useDispatch();
    const [showFilter, setShowFilter] = useState(true);
    const { register, handleSubmit } = useForm();
    const [selectedUser, setSelectedUser] = useState(null);
    const [popUser, setPopUser] = useState({ show: false });
    const [modalSMS, setModalSMS] = useState({ show: false });
    const filterData = useRef({});
    const filterState = useSelector(state => state.StaffData.staffSearchFilters);
    if (filterState) {
        filterData.current = { ...filterState };
    }
    const { staffExtSettings } =
        useSelector(state => {
            return {
                staffExtSettings: state.SystemSettingsReducer.staffExtSettings
            }
        });
    const tableCols = [
        { colName: "RowNumber", colTitle: "ردیف", showInMobile: true },
        { colName: "Code", colTitle: "کد", showInMobile: true },
        { colName: "FirstName", colTitle: "نام", showInMobile: true },
        { colName: "LastName", colTitle: "نام خانوادگی", showInMobile: true },
        { colName: "Mobile", colTitle: "موبایل", showInMobile: false },
        { colName: "Phone", colTitle: "تلفن", showInMobile: false }
    ];
    const tableRowButtons = [
        { title: "نمایش", type: "common", className: "group-Btn-smalll btn-secondary", onclick: rowClick, showCondition: () => isMobileApp() },
        {
            title: "حذف ", type: "delete", className: "group-Btn-smalll btn-danger", onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'حذف پرسنل',
                    dialogText: 'آیا از حذف مطمئن هستید؟',
                    okOperation: deleteStaff(item.ID, () => search(filterData.current))
                }))
            }
        }
    ];
    function rowClick(row) {
        history.push(`/BaseInfo/AddEditPersonnel/${row.ID}`);
    }
    function showHideFilter(hide) {
        const divFilters = document.getElementById("divFilters");
        if (hide) {
            divFilters.classList.add("hiddenRow");
            setShowFilter(false);
        }
        else {
            divFilters.classList.remove("hiddenRow");
            setShowFilter(true);
        }
    }
    function search(data) {
        data.Skip = 0;
        data.IsOfficePersonel = true;
        filterData.current = { ...data };
        dispatch(searchStaff(data));
    }
    function clearFilters() {
        frmFilters.current.reset();
        dispatch(searchStaff({ Take: 10, Skip: 0, IsOfficePersonel:true }));
    }
    function showModalUser() {
        const onSelect = (data) => {
            if (filterState) {
                filterState.RelatedUserID = "";
                filterState.RelatedUserName = ""
            }
            setSelectedUser(data);
        }
        setPopUser({
            show: true,
            selectUserWithName: onSelect
        })
    }
    function showModalSMS() {
        const onGetMobile = (data) => {
            if (!data || !data.Data || !Array.isArray(data.Data)) {
                setErrorDialog(dispatch, data.Message ?? data.Error ?? "Error", "دریافت شماره های همراه");
                return;
            }
            const mobiles = data.Data.join(",");
            setModalSMS({
                show: true,
                to: mobiles,
                filterData: filterData.current
            })
        }
        getStaffMobilesByFilter(filterData.current, onGetMobile);
    }
    useEffect(() => {
        dispatch(getStaffExtSettings());
        document.body.classList = "notMain";
        document.title = "بی همتا-اطلاعات پایه";
    }, [])
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card>
                <Card.Header className="headerStyle">
                    <span>
                        <FontAwesomeIcon icon={faSearch} size="lg" />&nbsp;
                        جستجوی پرسنل
                    </span>
                </Card.Header>
                <Card.Body className="bodyStyle">
                    <ModalSelectUser popData={popUser} setUserPop={setPopUser} />
                    <ModalSendSMS popData={modalSMS} setPopData={setModalSMS} templateType="staffs" sendFromModel="staff" />
                    <form onSubmit={handleSubmit(search)} ref={frmFilters}>
                        <Row className="rowBorder" id="divFilters">
                            <div className="rowTitle">
                                فیلترهای جستجو
                                &nbsp;
                                {showFilter && <EyeSlashFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(true)} />}
                                {!showFilter && <EyeFill size={20} className="hoverIcon" style={{ cursor: "pointer", color: "#ca237e" }} onClick={() => showHideFilter(false)} />}
                                {showFilter && <FontAwesomeIcon icon={faBroom} size="lg" style={{ cursor: "pointer", color: "#007e80" }} onClick={clearFilters} />}
                            </div>
                            <Col md={2} className="form-group">
                                <label>کد:</label>
                                <Form.Control name="Code" ref={register({})} defaultValue={filterState?.Code ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>نام:</label>
                                <Form.Control name="FirstName" ref={register({})} defaultValue={filterState?.FirstName ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>نام خانوادگی:</label>
                                <Form.Control name="Name" ref={register({})} defaultValue={filterState?.Name ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>شماره همراه: </label>
                                <Form.Control name="Mobile" ref={register({})} defaultValue={filterState?.Mobile ?? ""} />
                            </Col>
                            <Col md={2} className="form-group">
                                <label>کاربر مرتبط: </label>
                                <input type="hidden" name="RelatedUserID" ref={register({})} readOnly value={selectedUser?.ID ?? filterState?.RelatedUserID ?? ""} />
                                <Form.Control name="RelatedUserName" readOnly value={selectedUser?.Name ?? filterState?.RelatedUserName ?? ""} />
                                <Button className="btn-input-tiny" style={{ top: "26px" }} onClick={showModalUser}><List size={20} /></Button>
                            </Col>
                            {staffExtSettings && Array.isArray(staffExtSettings) &&
                                staffExtSettings.map((ext, i) =>
                                    <Col md={2} className="form-group" key={i}>
                                        <label>{ext.SettingValue}</label>
                                        <Form.Control name={`ExtraAttr${i + 1}`} ref={register({})} defaultValue={filterState ? filterState[`ExtraAttr${i + 1}`] ?? "" : ""} />
                                    </Col>)
                            }
                            <Col md={2} className="form-group" style={{ display: "flex", alignItems: "center", color: "blue" }}>
                                <div className="rowBorder form-group mt-4" style={{ padding: "8px 5px 8px 5px", width: "100%" }}>
                                    <input type="checkbox" name="IsActive" id="IsActive" className="form-check-input" ref={register({})} defaultChecked={filterState?.IsActive} />
                                    &nbsp;
                                    <label htmlFor="IsActive">فعال</label>
                                    &nbsp;
                                    &nbsp;
                                    <input type="checkbox" name="IsBlackList" id="IsBlackList" className="form-check-input" ref={register({})} defaultChecked={filterState?.IsBlackList} />
                                    &nbsp;
                                    <label htmlFor="IsBlackList">لیست سیاه</label>
                                    &nbsp;
                                </div>
                            </Col>
                        </Row>
                        <div className="mt-1">
                            <Button type="submit" variant="secondary" className="group-Btn-large"><Search size={18} />&nbsp;جستجوی پرسنل</Button>
                            <Button className="group-Btn-large" onClick={showModalSMS}><Envelope size={15} />&nbsp;ارسال پیامک به لیست</Button>
                        </div>
                    </form>
                    <BihamtaTable columns={tableCols} rowButtons={tableRowButtons} filterData={filterData.current} rowClick={rowClick}
                        searchMethod={(data) => dispatch(searchStaff(data))} reducerName="StaffData" objectName="searchStaffList" hasPaging={true} />
                </Card.Body>
            </Card>
        </div>
    )
}
export default SearchPersonnel;